var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9167 17.0825V12.0825M15.9167 12.0825L17.5833 13.7492M15.9167 12.0825L14.25 13.7492",
    stroke: "#526C7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4167 10.4167C18.4167 7.27417 18.4167 5.7025 17.44 4.72667C16.4642 3.75 14.8925 3.75 11.75 3.75H8.41667C5.27417 3.75 3.7025 3.75 2.72667 4.72667C1.75 5.7025 1.75 7.27417 1.75 10.4167C1.75 13.5592 1.75 15.1308 2.72667 16.1067C3.7025 17.0833 5.27417 17.0833 8.41667 17.0833H11.75M8.41667 13.75H5.08333M10.9167 13.75H10.5M1.75 8.75H18.4167",
    stroke: "#526C7B",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderLight);
export default __webpack_public_path__ + "static/media/calenderLight.242568a089ab01f0872e8672405ce9c1.svg";
export { ForwardRef as ReactComponent };